import { render, staticRenderFns } from "./SelectVideoFormatModal.vue?vue&type=template&id=3b049eec&scoped=true&"
import script from "./SelectVideoFormatModal.vue?vue&type=script&lang=ts&"
export * from "./SelectVideoFormatModal.vue?vue&type=script&lang=ts&"
import style0 from "./SelectVideoFormatModal.vue?vue&type=style&index=0&id=3b049eec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b049eec",
  null
  
)

export default component.exports